import Head from 'next/head';
import Accordion from '@/components/Accordion';

const Page: React.FC = () => {
  return (
    <>
      <Head>
        <title>Accordions</title>
      </Head>

      <Accordion title={'Accordions'} />
    </>
  );
};

export default Page;
